module.exports = __webpack_public_path__ + "static/img/stoerer_produkt.b7f0467.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stoerer_produkt.png
// module id = etzk
// module chunks = 2